import { jsx as _jsx } from "preact/jsx-runtime";
import { useState } from 'react';
import { CollapsibleBanner } from 'pathfinder/modules/shared/CollapsibleBanner/CollapsibleBanner';
import { NotificationTypes } from 'pathfinder/modules/NotificationCMS/interfaces/types';
import { saveToMyFandoms } from './utils/fandomsStorage';
import SecureTabOpener from 'pathfinder/utils/secureTabOpener';
import pushOptimizelyEvent from 'pathfinder/utils/pushOptimizelyEvent';
export const AddToMyFandomsNotificationModule = ({ isMobile, track }) => {
    const [isBannerExpanded, setIsBannerExpanded] = useState(true);
    const [isBannerDismissed, setIsBannerDismissed] = useState(false);
    const { current } = window.SilverSurferSDK.getContext();
    if (isBannerDismissed) {
        return null;
    }
    return (_jsx(CollapsibleBanner, { body: 'Keep up with the latest news and discussions about this fandom on FanCentral.', cta: 'FOLLOW FANDOM', type: NotificationTypes.addToMyFandoms, isMobile: isMobile, isExpanded: isBannerExpanded, onCTAClick: (e) => {
            e.preventDefault();
            const wikiId = current.productId;
            setIsBannerDismissed(true);
            track.click({ label: 'add-to-my-fandoms' });
            pushOptimizelyEvent('pathfinder_add_to_my_fandoms_click');
            saveToMyFandoms(wikiId).then(() => setTimeout(() => SecureTabOpener('//fandom.com/fancentral/home'), 2000));
        }, onImpression: () => track.impression({ label: `add-to-my-fandoms` }), onArrowClick: () => setIsBannerExpanded(!isBannerExpanded) }, void 0));
};
